<template>
  <v-app class="grey lighten-3">
    <v-layout>
      <v-dialog v-model="error" width="500">
        <v-card>
          <v-card-title class="headline red accent-3" primary-title>
            Warning Message
          </v-card-title>

          <v-card-text>
            {{ errorMsg }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red accent-3" flat @click="close">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <v-snackbar
          v-model="snackbar"
          :right="x === 'right'"
          :timeout="timeout"
          color="black"
          :top="y === 'top'"
        >
          {{ errorMsg }}
          <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </div>
      <v-flex xs12 sm12 md12>
        <v-card>
          <v-card-text>
            <v-card-title class="project">
              <div class="white--text headline">
                <span>Project Response Location</span>
              </div>
              <v-spacer></v-spacer>
              <v-btn flat color="white" @click="editingProjectPage">
                Editing project page
              </v-btn>
              <v-btn flat color="white" @click="createQuestion">Question</v-btn>
            </v-card-title>
            <v-card-text>
              <v-toolbar flat color="white">
                <div class="text-xs-center">
                  <v-btn
                    medium
                    color="primary"
                    class="white--text"
                    @click="xlsFileUpload"
                  >
                    Upload XLS File
                    <v-icon right dark>cloud_upload</v-icon>
                  </v-btn>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  align="center"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2 text-none"
                      v-on="on"
                    >
                      Add Location
                      <v-icon>add_location</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline primary">
                      {{ formTitle }}
                    </v-card-title>
                    <v-form ref="form" lazy-validation>
                      <v-card row>
                        <v-card-text>
                          <v-layout row>
                            <v-flex xs6>
                              <v-select
                                required
                                box
                                v-model="addressData.division_id"
                                :items="indexData.divisions"
                                label="Select division"
                                item-text="english_title"
                                item-value="id"
                                @change="division"
                              ></v-select>
                            </v-flex>
                            <v-flex xs6>
                              <v-autocomplete
                                required
                                box
                                v-model="addressData.district_id"
                                :items="addressData.filterDistricts"
                                label="Select district"
                                item-text="english_title"
                                item-value="id"
                                @change="district"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs6>
                              <v-autocomplete
                                required
                                box
                                v-model="addressData.upazila_id"
                                :items="addressData.filterUpazilas"
                                label="Select Upazila"
                                item-text="english_title"
                                item-value="id"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model.lazy="addressData.zip_code"
                                box
                                label="Zip code"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs12>
                              <v-text-field
                                v-model.lazy="addressData.area"
                                box
                                label="Area"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs6>
                              <v-text-field
                                v-model.lazy="addressData.latitude"
                                required
                                box
                                label="Latitude*"
                                :rules="[(v) => !!v || 'Latitude is required!']"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model.lazy="addressData.longitude"
                                required
                                box
                                label="Longitude*"
                                :rules="[
                                  (v) => !!v || 'Longitude is required!',
                                ]"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs12>
                              <v-text-field
                                v-model.lazy="addressData.address"
                                box
                                label="Address"
                                :rules="[(v) => !!v || 'Address is required!']"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn class="primary" flat @click="close">
                            Close
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn class="primary" flat @click="submit">
                            Submit
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-toolbar>

              <v-data-table
                :search="search"
                :headers="headers"
                :items="indexData.importLoc"
                class="elevation-1"
              >
                <v-progress-linear
                  color="blue"
                  indeterminate
                ></v-progress-linear>
                <template slot="headerCell" slot-scope="props">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{ props.header.text }}
                      </span>
                    </template>
                    <span>
                      {{ props.header.text }}
                    </span>
                  </v-tooltip>
                </template>
                <template
                  v-if="indexData.totImportedLoc > 0"
                  v-slot:items="props"
                >
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.project_id }}</td>
                  <td>{{ props.item.division_name }}</td>
                  <td>{{ props.item.district_name }}</td>
                  <td>{{ props.item.upazila_name }}</td>
                  <td>{{ props.item.area }}</td>
                  <td>{{ props.item.zip_code }}</td>
                  <td>{{ props.item.latitude }}</td>
                  <td>{{ props.item.longitude }}</td>
                  <td>{{ props.item.address }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon small class="mr-2" @click="editItem(props.item)">
                      edit
                    </v-icon>
                    <v-icon small @click="deleteItem(props.item.id)">
                      delete
                    </v-icon>
                  </td>
                </template>
                <template v-else v-slot:no-data>
                  <v-alert :value="true" color="error" icon="warning">
                    No Data Here
                  </v-alert>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card-text>
          <v-layout>
            <XLFileUpload
              v-if="openUploadDialod == 1"
              @change="changeOpenDialog($event)"
            ></XLFileUpload>
          </v-layout>
          <v-card-actions>
            <v-btn class="button" flat @click="back">Back</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="button" flat @click="next">Next</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
  import axios from "axios";
  import { ROOT_URL } from "@/api/connectingUrls";
  import { mapGetters } from "vuex";
  import XLFileUpload from "@/components/XlsImport/XlsFileUpload";
  import router from "@/router";

  export default {
    components: {
      XLFileUpload,
    },
    data: () => ({
      apiUrl: "response-location",
      editedIndex: -1,
      dialog: false,
      openUploadDialod: 0,
      search: "",
      snackbar: false,
      y: "top",
      x: "right",
      timeout: 4000,
      error: "",
      errorMsg: "",
      addressData: {
        id: null,
        division_id: "",
        district_id: "",
        upazila_id: "",
        area: "",
        zip_code: "",
        address: "",
        latitude: "",
        longitude: "",
        filterDistricts: [],
        filterUpazilas: [],
        totImportedLoc: 0,
        project_id: "",
      },
      defaultItem: {},
      AddressSubmitData: {
        data: [],
      },
      headers: [
        { text: "Id", align: "left", value: "id" },
        { text: "Project Id", align: "left", value: "project_id" },
        { text: "Division", align: "left", value: "division_name" },
        { text: "District", align: "left", value: "district_name" },
        { text: "Upazila", align: "left", value: "upazila_name" },
        { text: "Area", sortable: false, value: "area" },
        { text: "Zip Code", sortable: false, value: "zip_code" },
        { text: "Latitude", sortable: false, value: "latitude" },
        { text: "Longitude", sortable: false, value: "longtude" },
        { text: "Address", value: "address" },
        { text: "Actions", align: "center", value: "actions" },
      ],
    }),

    computed: {
      ...mapGetters(["isLoggedIn", "indexData", "statusCode"]),
      formTitle() {
        return this.editedIndex === -1
          ? "Add New Location"
          : "Edit Existing Location";
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        var project_id = localStorage.getItem("project_id_modify");
        this.addressData.project_id = project_id;
        this.$store.dispatch("indexData", [this.apiUrl, project_id]);
      },
      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },
      changeOpenDialog() {
        this.openUploadDialod = 0;
      },
      xlsFileUpload() {
        if (this.openUploadDialod == 1) {
          this.openUploadDialod = 0;
        } else {
          this.openUploadDialod = 1;
        }
      },

      editItem(item) {
        // console.log(item);
        this.editedIndex = this.indexData.importLoc.indexOf(item);
        this.addressData.id = item.id;
        this.addressData.division_id = item.division_id;
        this.addressData.district_id = item.district_id;
        this.addressData.upazila_id = item.upazila_id;
        this.addressData.area = item.area;
        this.addressData.zip_code = item.zip_code;
        this.addressData.address = item.address;
        this.addressData.latitude = item.latitude;
        this.addressData.longitude = item.longitude;
        this.dialog = true;
      },

      async deleteItem(itemId) {
        var popUpMsg = confirm(
          "Are you sure you want to delete this location?"
        );
        if (popUpMsg) {
          try {
            const token = window.localStorage.getItem("datadash_token");
            if (token != null) {
              return await axios
                .delete(`${ROOT_URL}/${this.apiUrl}/${itemId}`, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                })
                .then((response) => {
                  // console.log(response);
                  if (response.data.error == 0) {
                    this.error = response.data.error;
                    this.errorMsg = response.data.errorMsg;
                    this.snackbar = true;
                    this.dialog = false;
                    setTimeout(() => {
                      this.initialize();
                    }, 400);
                  } else {
                    this.error = response.data.error;
                    this.errorMsg = response.data.errorMsg;
                  }
                });
            }
          } catch (error) {
            // console.log(error);
          }
        }
      },
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.addressData = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
      division() {
        let divisionId = this.addressData.division_id;
        if (divisionId != undefined) {
          let districtsValue = [];
          for (let i = 0; i < this.indexData.districts.length; i++) {
            if (this.indexData.districts[i].division_id == divisionId) {
              districtsValue.push(this.indexData.districts[i]);
            }
          }
          this.addressData.filterDistricts = districtsValue;
        }
      },

      district() {
        let districtId = this.addressData.district_id;
        if (districtId != undefined) {
          let upazilasValue = [];
          for (let i = 0; i < this.indexData.upazilas.length; i++) {
            if (this.indexData.upazilas[i].district_id == districtId) {
              upazilasValue.push(this.indexData.upazilas[i]);
            }
          }
          this.addressData.filterUpazilas = upazilasValue;
        }
      },
      editingProjectPage: function () {
        var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          project_id,
          "/edit-project",
        ]);
      },
      createQuestion: function () {
        localStorage.setItem("no_of_address", this.indexData.totImportedLoc);
        var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
        this.$store.dispatch("indexDataAndRout", [
          "question-json",
          project_id,
          "/edit-question",
        ]);
      },
      back() {
        var project_id = JSON.parse(localStorage.getItem("project_id_modify"));
        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          project_id,
          "/edit-project",
        ]);
      },
      next() {
        if ((this.totalLocation = !undefined)) {
          localStorage.setItem("no_of_address", this.indexData.totImportedLoc);
          if (this.indexData.projectData.has_pre_survey == 1) {
            router.push("/edit-pre-survey-question");
          } else {
            router.push("/edit-question");
          }
        } else {
          alert("Total number of location is undefined!");
        }
      },
      async submit() {
        // console.log(this.addressData);
        try {
          const token = window.localStorage.getItem("datadash_token");
          if (token != null) {
            return axios
              .post(`${ROOT_URL}/${this.apiUrl}`, this.addressData, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                // console.log(response);
                if (response.data.error == 0) {
                  this.error = response.data.error;
                  this.errorMsg = response.data.errorMsg;
                  this.snackbar = true;
                  this.dialog = false;
                  setTimeout(() => {
                    this.initialize();
                  }, 400);
                } else {
                  this.error = response.data.error;
                  this.errorMsg = response.data.errorMsg;
                }
              });
          }
        } catch (error) {
          // console.log(error);
        }
      },
    },
  };
</script>

<style scoped>
  .icon {
    background: #ff2e2e;
    color: aliceblue;
    cursor: pointer;
    border-radius: none;
    margin: 10px;
  }
  .button {
    font-size: 16px;
    background: #ff2e2e;
    padding: 0.4rem 1.3rem;
    text-align: center;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    margin: 10px;
    color: white;
  }
  .delete {
    color: #3f51b5;
    cursor: pointer;
  }
  span {
    width: 20px;
    cursor: pointer;
  }
  .no-upercase {
    text-transform: unset !important;
  }
  .text_color {
    color: white;
  }
  .project {
    background: #ff2e2e;
  }
</style>
